"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _journeyProduct = _interopRequireDefault(require("./journey-product"));
var _productOption = _interopRequireDefault(require("./product-option"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var processProduct = function processProduct(_ref) {
  var fields = _ref.fields;
  var isExtra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var optionsAvailableSeparately = (0, _utils.getProp)(fields, 'optionsAvailableSeparately');
  var optionsData = (0, _utils.getProp)(fields, 'options') || [];
  var options = optionsData.filter(function (option) {
    var _option$fields, _option$fields$site;
    return option === null || option === void 0 ? void 0 : (_option$fields = option.fields) === null || _option$fields === void 0 ? void 0 : (_option$fields$site = _option$fields.site) === null || _option$fields$site === void 0 ? void 0 : _option$fields$site.includes(process.env.NEXT_PUBLIC_SITE);
  }).filter(function (option) {
    return (0, _utils.getProp)(option.fields, 'inStock');
  }).map(function (option) {
    return (0, _productOption["default"])(option);
  });
  if (optionsAvailableSeparately) {
    return options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        productId: (0, _utils.getProp)(fields, 'identifier'),
        productName: (0, _utils.getProp)(fields, 'name'),
        motif: (0, _utils.getProp)(fields, 'motif'),
        isExtra: isExtra,
        mutuallyExclusive: (0, _utils.getProp)(fields, 'mutuallyExclusive', false)
      });
    });
  }
  return (0, _journeyProduct["default"])(_objectSpread(_objectSpread({}, fields), {}, {
    options: options,
    isExtra: isExtra
  }));
};
var processProducts = function processProducts(products) {
  var isExtra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!products) return [];
  return products.filter(function (product) {
    var _product$fields, _product$fields$site;
    return product === null || product === void 0 ? void 0 : (_product$fields = product.fields) === null || _product$fields === void 0 ? void 0 : (_product$fields$site = _product$fields.site) === null || _product$fields$site === void 0 ? void 0 : _product$fields$site.includes(process.env.NEXT_PUBLIC_SITE);
  }).filter(function (product) {
    return (0, _utils.getProp)(product.fields, 'inStock');
  }).map(function (product) {
    return processProduct(product, isExtra);
  }).flat();
};
var orderJourneyProductsFactory = function orderJourneyProductsFactory(productLine) {
  var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var products = (0, _utils.getProp)(productLine === null || productLine === void 0 ? void 0 : productLine.fields, 'products') || [];
  var p = processProducts(products);
  var e = processProducts(extras, true);
  return [].concat(_toConsumableArray(p), _toConsumableArray(e));
};
var _default = orderJourneyProductsFactory;
exports["default"] = _default;